import React from 'react';
import { ProfileRouteStop } from '../profileTypes';
import styles from './RoutePlanCard.module.css';

interface RoutePlanCardProps {
  stops: ProfileRouteStop[];
}

export const RoutePlanCard: React.FC<RoutePlanCardProps> = ({ stops }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Today's Route Plan</h3>
      <div className={styles.list}>
        {stops.map((stop) => (
          <div key={stop.id} className={styles.row}>
            <span
              className={`${styles.indexDot} ${
                stop.status === 'Completed' ? styles.dotDone : styles.dotPending
              }`}
            >
              {stop.status === 'Completed' ? '✓' : stop.index}
            </span>
            <div className={styles.info}>
              <p className={styles.name}>{stop.name}</p>
              <p className={styles.time}>{stop.time}</p>
            </div>
            <span
              className={`${styles.statusBadge} ${
                stop.status === 'Completed' ? styles.badgeDone : styles.badgePending
              }`}
            >
              {stop.status}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
